import { createSlice, PayloadAction, Dispatch } from "@reduxjs/toolkit";
import { GetRoomMembershipsResult, RoomMetadata } from "interfaces/coaching";
import { getServicesManager } from "services";


export interface LeaderboardMembershipsState {
  memberships: GetRoomMembershipsResult | null;
  isLoading: boolean;
  error: string | null;
}
const leaderboardMembershipsInitialState: LeaderboardMembershipsState = {
  memberships: null,
  isLoading: false,
  error: null
};

export const leaderboardMembershipsSlice = createSlice({
  name: 'leaderboardMemberships',
  initialState: leaderboardMembershipsInitialState,
  reducers: {
    setMemberships: (state, action: PayloadAction<GetRoomMembershipsResult>) => {
      state.memberships = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    addOrUpdateMembership: (state, action: PayloadAction<RoomMetadata>) => {
      if (!state.memberships) {
        state.memberships = [action.payload];
        return;
      }

      const index = state.memberships.findIndex(m => m.room_id === action.payload.room_id);
      if (index !== -1) {
        state.memberships[index] = action.payload;
      } else {
        state.memberships.unshift(action.payload);
      }
    },
    setLeaderboardLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setLeaderboardError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    }
  }
});

export const { setMemberships, addOrUpdateMembership, setLeaderboardLoading, setLeaderboardError } = leaderboardMembershipsSlice.actions;

export function loadLeaderboardMemberships(dispatch: Dispatch): Promise<GetRoomMembershipsResult | null> {
  dispatch(leaderboardMembershipsSlice.actions.setLeaderboardLoading(true));
  const result = getServicesManager().getUserMemberships();
  result.then(v => {
    if (v !== null) {
      dispatch(leaderboardMembershipsSlice.actions.setMemberships(v));
    } else {
      dispatch(leaderboardMembershipsSlice.actions.setLeaderboardError('Failed to load memberships'));
    }
  }).catch(error => {
    dispatch(leaderboardMembershipsSlice.actions.setLeaderboardError(error.message));
  });
  return result;
}
